export default __webpack_public_path__ + "static/media/oneplusone.dc09d4d4.jpg";